import script from "./ComebackOffersView.vue?vue&type=script&setup=true&lang=js"
export * from "./ComebackOffersView.vue?vue&type=script&setup=true&lang=js"

import "./ComebackOffersView.vue?vue&type=style&index=0&id=0f04ace1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f04ace1"]])

export default __exports__